(function($) {
    $(document).ready(function() {

        // define slideshow element
        var $slideshow = $('.slides-home');

        // add aditional api function to grab data attached to the slide
        $slideshow.on('cycle-bootstrap', function(e, opts, API) {

            // get the slide pager text (the page title)
            API.getSlidePager = function( slideOpts, opts, slideEl ) {
                return $( slideEl ).data('pager-text');
            };

            // get the slide link (permalink)
            API.getSlideLink = function( slideOpts, opts, slideEl ) {
                return $( slideEl ).data('pager-link');
            };
        });

        var options = {
            slides : '.slide',
            pager : '.pager',
            prev : '.cycle-prev',
            next : '.cycle-next',
            pagerTemplate : '<span class="pager-item bold"><span class="pager-text">{{API.getSlidePager}}</span></span>',
            pauseOnHover : false,
            swipe : true
        };

        $slideshow.cycle(options);

        $( '.slides-page' ).on( 'cycle-next cycle-prev cycle-initialized', function(event, optionHash ){

            $('.js-current-slide').text(optionHash.currSlide + 1 + ' / ');
            $('.js-total-slides').text(optionHash.slideCount);

        });

        $('.slides-page').cycle({
            'slides' : '.slide',
            'prev' : '.slideshow-navigation .cycle-prev',
            'next' : '.slideshow-navigation .cycle-next',
            'pager' : '.pager',
            'pagerTemplate' : "<span class='pager-item'>{{slideNum}} / {{slideCount}}</span>",
            'pauseOnHover' : true,
            'paused' : true,
            'swipe' : true,
            'autoHeight' : 'container'
        });

    });
})(jQuery);
